'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Progress_module = require('../styles/Progress.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

function validProgress(progress) {
    if (!progress || progress < 0) {
        return 0;
    }
    if (progress > 100) {
        return 100;
    }
    return progress;
}
/**
 * @description The progress component displays the length of a process
 *
 * @component
 * @example
 * ```jsx
 * <Progress percent={30} />
 * ```
 */
const Progress = React__namespace.forwardRef((props, ref) => {
    const { percent, className, ...restProps } = props;
    const cx = reactUtils.useStyles(Progress_module.default);
    const classNames = cx(className, 'container');
    const percentStyle = {
        width: `${validProgress(percent)}%`,
    };
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "Progress", className: classNames, ...restProps },
        React__namespace.createElement("div", { className: cx('inner') },
            React__namespace.createElement("div", { className: cx('progress'), style: percentStyle }))));
});
Progress.defaultProps = {
    percent: 0,
};
Progress.displayName = 'Progress';

exports.Progress = Progress;
//# sourceMappingURL=Progress.js.map
